import moment from "moment";
import { firebaseClient } from "firebaseClient";
import { removeResharedPosts } from "components/analytics/utils";

export const getStatsBetween = async (account, start, end, firebaseServer = firebaseClient) => {
    const db = firebaseServer.firestore();

    const docs = await db
        .collection("linkedinAccounts")
        .doc(account.idLinkedin)
        .collection("accountStats")
        // @ts-ignore
        .where("dateFetched", ">=", start)
        // @ts-ignore
        .where("dateFetched", "<=", end)
        .get();

    const stats: any = [];
    docs.forEach((doc) => {
        stats.push(doc.data());
    });

    return stats[0];
};

export const getTweetsStats = async (account, timeFrame, firebaseServer = firebaseClient as any) => {
    let docs;
    let query = getTweetStatsQuery(account, firebaseServer);

    if (timeFrame.start) {
        query = query
            .where("created_at", ">=", timeFrame.start)
            .where("created_at", "<=", timeFrame.end)
    } else {
        query = query
            .where("created_at", "<=", moment().endOf("day").toDate())
            .where("created_at", ">", timeFrame)
    }

    docs = await query.get();

    // console.log("nb tweets: " + docs.docs.length);

    const stats: any = [];
    docs.forEach((doc) => {
        let tw = doc.data();
        stats.push(tw);
    });

    return stats;
}

export const getTopTweetsStats = async (account, timeFrame?: any, firebaseServer = firebaseClient as any) => {
    let docs;
    let query = getTweetStatsQuery(account, firebaseServer);

    if (timeFrame) {
        if (timeFrame.start) {
            query = query
                .where('created_at', '>=', timeFrame.start)
                .where('created_at', '<=', timeFrame.end);
        } else {
            query = query
                .where('created_at', '<=', moment().endOf('day').toDate())
                .where('created_at', '>', timeFrame);
        }
    }

    docs = await query.get();

    let stats: any = [];
    docs.forEach((doc) => {
        let tw = doc.data();
        stats.push(tw);
    });
    stats = await removeResharedPosts(stats);
    stats = stats.sort((a, b) => {
        return (b?.numViews || 0) - (a?.numViews || 0);
    });
    return stats.slice(0, 4);
}

const getTweetStatsQuery = (account, firebaseServer = firebaseClient as any) => {
    const db = firebaseServer.firestore();

    let query = db.collection("linkedinPosts");
    
    if(account?.dashEntityUrn){
        query = query.where("user.dashEntityUrn", "==", account?.dashEntityUrn);
    }
    else if (account.username) {
        query = query.where("user.username", "==", account.username);
    }
    else {
        query = query.where("user.id", "==", account.idLinkedin);
    }
    return query
    }

export const getAccountStats = async (account, timeFrame, firebaseServer = firebaseClient as any, collection = "linkedinAccounts") => {

    const db = firebaseServer.firestore();
    let docs;
    let wasEmpty = false;
    // @ts-ignore
    if (timeFrame.start) {
        docs = await db
            .collection(collection)
            .doc(account.idLinkedin)
            .collection("accountStats")
            // @ts-ignore
            .where("dateFetched", ">=", timeFrame.start)
            // @ts-ignore
            .where("dateFetched", "<=", timeFrame.end)
            .orderBy("dateFetched", "asc")
            .get();
    } else {
        docs = await db
            .collection(collection)
            .doc(account.idLinkedin)
            .collection("accountStats")
            .where("dateFetched", "<=", moment().endOf("day").toDate())
            .where("dateFetched", ">", timeFrame)
            .orderBy("dateFetched", "asc")
            .get();
    }

    if (docs?.empty) {
        docs = await db
            .collection(collection)
            .doc(account.idLinkedin)
            .collection("accountStats")
            .where("dateFetched", "<=", (timeFrame?.start) ? timeFrame.start : timeFrame)
            .where("dateFetched", ">", moment((timeFrame.start) ? timeFrame.start : timeFrame).endOf("day").subtract('60', "days").toDate())
            .orderBy("dateFetched", "desc").limit(1)
            .get(); //get most recent
        wasEmpty = true;
    }

    const stats: any = [];
    docs.forEach((doc) => {
        const data = doc.data();
        if (wasEmpty) {

            if (data?.dateFetched?._seconds) {
                data.dateFetched =
                {
                    _seconds: moment((timeFrame?.start) ? timeFrame?.start : timeFrame).startOf("day")?.unix(),
                    _nanoseconds: data?.dateFetched?._nanoseconds || data?.dateFetched?.nanoseconds,
                };
            } else {
                data.dateFetched = firebaseClient.firestore.Timestamp.fromDate(
                    moment(
                        (timeFrame?.start) ? timeFrame.start : timeFrame
                    )?.toDate()
                );
            }
            // console.log(data.dateFetched);
        }
        stats.push(data);
    });

    return stats;
}
